
export const IconCard = ({ name, src, description }) => {
    return (
        <div className="flex items-start space-x-4">
            <img src={src} className="w-16 h-16" alt={name} />
            <div>
                <h3 className="text-lg font-semibold text-gray-800">{name}</h3>
                <p className="mt-2 text-base text-gray-600">{description}</p>
            </div>
        </div>
    );
};